/**
 * Tasks whose job is translating text — their test takes a language. Matches
 * TRANSLATION_TASKS in pen-space-backend's config/aiTasks.js, plus the
 * Overview translation review (layer 2), which tests the same way.
 */
export const TRANSLATION_TASKS = ["translation", "overviewTranslation", "overviewTranslationReview", "aboutTheBookTranslation"];

/**
 * Translation tasks tested on a REAL book, whose run comes back as sections
 * side by side: the Overview's two layers, and a book's About the Book.
 */
const OVERVIEW_TRANSLATION_TASKS = ["overviewTranslation", "overviewTranslationReview", "aboutTheBookTranslation"];

export const isTranslationTask = (key) => TRANSLATION_TASKS.includes(key);

/**
 * Tasks whose test runs against a real book. Overview translation is both: it
 * translates that book's Overview into the chosen language.
 */
export const testsOnBook = (key) => !isTranslationTask(key) || OVERVIEW_TRANSLATION_TASKS.includes(key);

/**
 * An Overview translation run on a book — sections side by side, savable. A
 * review run also carries each section's first draft and the review's verdict.
 */
export const isOverviewTranslationRun = (run) =>
  OVERVIEW_TRANSLATION_TASKS.includes(run?.key) && Array.isArray(run.fields);

